export default __webpack_public_path__ + "static/media/Student logo.1e5fb0a5.png";